import { emptyPaymentMethod, PaymentMethod } from "./payment-method";
import { emptyPaymentType, PaymentType } from "./payment-type";

export interface Payment {
  paymentId: number;
  externalCustomerId?: string;
  payorId?: number | string;
  patientId?: number;
  paymentMethodUsed?: PaymentMethod;
  patientEncounterId?: number;
  patientPaymentScheduleId?: number;
  patientPaymentMethodId?: number;
  paymentMethods?: PaymentMethod[];
  paymentAmt: number;
  automationFee?: number;
  merchantProcessingFee?: number;
  thirdPartyFee?: number;
  paymentAmtWithoutFees?: number;
  remPaymentAmt?: number;
  paymentType: PaymentType;
  paymentInitDt: string;
  authCode?: string;
  authExpirationDt?: string;
  isAuthExpired?: boolean;
  isManual?: boolean;
  isCaptured?:boolean;
  paymentStatus?: string;
  paymentStatusPending?: string;
  paymentStatusDt?: string;
  paymentAuthDt?: string;
  paymentCaptureDt?: string;
  paymentGroupId?: string;
  externalPaymentId?: string,
  externalResponse?: string;
  externalPayoutId?: string;
  isAuthOnly?: boolean;
  // mapped from transactions fields
  patientLedgerId?: number;
  transactionDesc?: string;
  paymentTypeName?: string;
  paymentStatusFailed?: string;
  paymentStatusSuccess?: boolean;
  receiptEmail?: string;
  paymentChannelId?: number;
  isRecurringDownPayment?: boolean;
}

export const emptyPayment = {
  paymentId: 0,
  externalCustomerId: '',
  payorId: 0,
  patientId: 0,
  paymentMethodUsed: emptyPaymentMethod,
  patientEncounterId: 0,
  patientPaymentScheduleId: 0,
  patientPaymentMethodId: 0,
  paymentMethods: [emptyPaymentMethod],
  paymentAmt: 0,
  automationFee: 0,
  merchantProcessingFee: 0,
  thirdPartyFee: 0,
  paymentAmtWithoutFees: 0,
  remPaymentAmt: 0,
  paymentType: emptyPaymentType,
  paymentInitDt: '',
  authCode: '',
  authExpirationDt: '',
  isAuthExpired: false,
  isManual: false,
  paymentStatus: '',
  paymentStatusPending: '',
  paymentStatusDt: '',
  paymentAuthDt: '',
  paymentCaptureDt: '',
  paymentGroupId: '',
  externalPaymentId: '',
  externalResponse: '',
  externalPayoutId: '',
  isAuthOnly: true,
}

export interface PaymentReversal {
  paymentReversalId: number;
  patientId: number;
  patientEncounterId: number;
  paymentId: number;
  reversalAmount?: number;
  externalReversalId: string;
  externalLedgerId?: string | number;
  reversalDate: string;
  reversalReason?: string;
  patientLedgerId: number;
  externalPayoutId?: string | number;
  clientPayoutId?: string | number;
}

export const emptyPaymentReversal: PaymentReversal = {
  paymentReversalId: 0,
  patientId: 0,
  patientEncounterId: 0,
  paymentId: 0,
  reversalAmount: 0,
  externalReversalId: '',
  externalLedgerId: '',
  reversalDate: '',
  reversalReason: '',
  patientLedgerId: 0,
  externalPayoutId: '',
  clientPayoutId: 0,
}

export interface PaymentDispute {
  paymentDisputeId: number,
  paymentId: number,
  patientId: number,
  patientEncounterId: number,
  externalDisputeId: number,
  disputeAmt: number,
  disputeDate: string,
  disputeReason: string,
  disputeStatus: string,
  disputeCloseDt: string,
  disputeCloseReason: string,
  patientLedgerId: number,
  externalPayoutId: string | number,
}

export const emptyDispute = {
  paymentDisputeId: 0,
  paymentId: 0,
  patientId: 0,
  patientEncounterId: 0,
  externalDisputeId: 0,
  disputeAmt: 0,
  disputeDate: '',
  disputeReason: '',
  disputeStatus: '',
  disputeCloseDt: '',
  disputeCloseReason: '',
  patientLedgerId: 0,
  externalPayoutId: 0,
}

export interface MasterPatientLedger {
  amount: number;
  iocId: string;
  initiatedDate: string;
  levelOfCare: string;
  status: string;
  transactionType: string;
  type: string;
}

export interface StripeErrorMessage {
  code: string;
  declineCode: string;
  message: string;
  type: string;
}